<script setup>
import { computed } from 'vue'
import Hos from '@/components/grid/cells/dispatch/Hos.vue'
import Alerts from '@/components/grid/cells/dispatch/Alerts.vue'
import FromTo from '@/components/grid/cells/dispatch/FromTo.vue'
import Status from '@/components/grid/cells/dispatch/Status.vue'
import Drivers from '@/components/grid/cells/dispatch/Drivers.vue'
import Primary from '@/components/grid/cells/dispatch/Primary.vue'
import StopBasic from '@/components/grid/cells/dispatch/StopBasic.vue'
import Assignment from '@/components/grid/cells/dispatch/Assignment.vue'
import AlertHeader from '@/components/grid/cells/dispatch/AlertHeader.vue'
import GeoLocation from '@/components/grid/cells/dispatch/GeoLocation.vue'
import GeoTimestamp from '@/components/grid/cells/dispatch/GeoTimestamp.vue'
import StopCondensed from '@/components/grid/cells/dispatch/StopCondensed.vue'
import AssignmentBasic from '@/components/grid/cells/dispatch/AssignmentBasic.vue'

/**
 * The custom cell renderer component map.
 *
 * @type {Object}
 */
const RENDERERS = {
    primary_column: Primary,
    hos: Hos,
    from_to: FromTo,
    drivers: Drivers,
    geo_location: GeoLocation,
    geo_timestamp: GeoTimestamp,
    stop_basic: StopBasic,
    stop_condensed: StopCondensed,
    assignment_basic: AssignmentBasic,
    assignment: Assignment,
    alerts: Alerts,
    status: Status,
    alerts_header: AlertHeader,
}

/**
 * The component's inherited properties.
 */
const props = defineProps({
    /**
     * The given params.
     *
     * @type {Object}
     */
    params: {
        type: Object,
        default: () => ({}),
    },
})

/**
 * Get the custom cell renderer component.
 *
 * @return {Component}
 */
const getCellComponent = computed(() => {
    if (extraParams.value?.type && RENDERERS[extraParams.value?.type]) {
        return RENDERERS[extraParams.value?.type]
    }

    console.error(
        'No custom cell render matches or no cell renderer type was defined.'
    )

    return null
})

/**
 * The row data.
 *
 * @return {Object}
 */
const data = computed(() => {
    return params.value?.data || {}
})

/**
 * ExtraParams object passed in by column definition.
 *
 * @return {Object}
 */
const extraParams = computed(() => {
    return params.value?.extraParams || {}
})

/**
 * All passed params.
 *
 * @return {Object}
 */
const params = computed(() => {
    return props.params || {}
})

/**
 * The value passed in via 'field' (could be an object that is a sub-object of full row)
 *
 * @return {Object}
 */
const value = computed(() => {
    return params.value?.value || {}
})
</script>

<template>
    <component
        :is="getCellComponent"
        :load="data"
        :value="value"
        :extra-params="extraParams"
    />
</template>
